const scrollLoader = document.querySelector('.scroll-loader');
const block = document.querySelector('.infinite-scroll');

const scrollListener = () => {
  const height = block.offsetHeight;
  const screenHeight = window.innerHeight;
  // Записываем, сколько пикселей пользователь уже проскроллил.
  const scrolled = window.scrollY;

  // Обозначим порог, по приближении к которому
  // будем вызывать какое-то действие.
  const threshold = height + block.getBoundingClientRect().top + scrolled;

  // Отслеживаем, где находится низ экрана относительно страницы.
  const position = scrolled + screenHeight;

  if (position >= threshold) {
    // Если мы пересекли полосу-порог, вызываем нужное действие.

    if (!scrollLoader) {
      return;
    }

    if (scrollLoader.classList.contains('hidden')) {
      scrollLoader.classList.remove('hidden');
      fetchProducts();
    }
  }
};

const fetchProducts = () => {
  // Эмуляция запроса на сервер
  setTimeout(() => {
    // Обрабатываем результат запроса
    // scrollLoader.classList.add('hidden');
  }, 3000);
};

const initScrollLoader = () => {
  if (!block) {
    return;
  }

  window.initScrollLoader = initScrollLoader;
  window.addEventListener('scroll', scrollListener);
  window.addEventListener('resize', scrollListener);
};

export {initScrollLoader};
